import React, { FC } from "react";
import Barcode from "react-barcode";

interface BarcodeComponentProps {
  value: string;
  width?: number;
  height?: number;
  fontSize?: number;
}

const BarcodeComponent: FC<BarcodeComponentProps> = ({ value, width = 2, height = 10, fontSize = 8 }) => {
  return <Barcode value={value} width={width} height={height} fontSize={fontSize} displayValue={true} />;
};

export default BarcodeComponent;
